import { atom } from 'recoil';

const pickMealEnd = atom<Date | null>({
  key: 'pickMealEnd',
  default: null,
});

export default pickMealEnd;
